module.exports = __webpack_public_path__ + "static/img/IMG_20240721_120549.982bf031.jpg";